type WindowWithGrowth = Window & {
  growth: (cmd: string, args: Record<string, unknown>)=> void
}

export default window as unknown as WindowWithGrowth
